import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '@/store/authStore';

/**
 * ProtectedRoute - Composant pour protéger les routes nécessitant une authentification
 *
 * @param {React.ReactNode} children - Composants enfants à rendre si autorisé
 * @param {Array} allowedRoles - Liste des rôles autorisés à accéder à cette route
 * @param {string} redirectTo - Chemin de redirection si non autorisé (par défaut: '/auth?tab=login')
 */
const ProtectedRoute = ({ children, allowedRoles = [], redirectTo = '/auth?tab=login' }) => {
  const { user, isAuthenticated, logout } = useAuthStore();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Plus besoin de vérifier avec le serveur - on fait confiance au store
    // L'authentification est déjà vérifiée lors de la connexion
    setIsChecking(false);
  }, []);

  // Pendant la vérification, ne rien afficher
  if (isChecking) {
    return null;
  }

  // Si l'utilisateur n'est pas authentifié, nettoyer le store et rediriger
  if (!isAuthenticated || !user) {
    // S'assurer que le store est nettoyé
    logout();
    // Rediriger vers la page de connexion
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Si des rôles spécifiques sont requis, vérifier que l'utilisateur a le bon rôle
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Rediriger vers la page d'accueil si le rôle n'est pas autorisé
    return <Navigate to="/" replace />;
  }

  // L'utilisateur est autorisé, rendre les enfants
  return children;
};

// La fonction getDashboardRouteForRole n'est plus nécessaire
// La logique de redirection est maintenant gérée par le backend

export default ProtectedRoute;
